import { useMutation } from 'react-query';
import { httpClient, UploadedFile } from '@vs-online-only-app/state';

interface UploadEmailMediaVariables {
  file: UploadedFile;
}

interface MediaUploadServiceResponse {
  url: string;
  contentType: string;
  filename: string;
}

export const useUploadEmailMedia = () => {
  return useMutation(
    ['uploadEmailMedia'],
    async ({ file }: UploadEmailMediaVariables) => {
      const response = await fetch(file.url);
      const blob = await response.blob();
      const newFile = new File([blob], `upload.${blob.type.split('/')[1]}`, {
        type: blob.type,
      });

      const formData = new FormData();
      formData.append('context', 'contact-email');
      formData.append('content', newFile, newFile.name);
      formData.append('contentType', newFile.type);

      const uploadResponse = await httpClient.post<MediaUploadServiceResponse>(
        '/media/upload/email-media',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      return uploadResponse.data;
    },
  );
};
